import Modal from '@web-ui-kit/modal'
import Text from '@web-ui-kit/text'

import * as Sc from '../Modals.styles'

import { useGlobalModalContext } from 'contexts/GlobalModalContext'
import { isMobile } from 'utils/rebrandingUtils'
import { useWindowDimensions } from 'hooks'
import i18n from 'i18n'

const ModalInfoUser = () => {
  const { store } = useGlobalModalContext()
  const { modalProps } = store || {}
  const { body, title, onCancel, password, username } = modalProps || {}

  const { width: windowWidth } = useWindowDimensions()

  const isFullScreenModal = isMobile(windowWidth)

  return (
    <Modal
      handleCloseModal={onCancel}
      isSmall={isFullScreenModal}
      topNav={{
        enableCloseIcon: true,
        title: title,
      }}
    >
      <Sc.ModalCredentialsContainer>
        <Sc.ModalCredentialsBody component='span' variant='body'>
          {body}
        </Sc.ModalCredentialsBody>
        <Sc.ModalCredentialsContent>
          <Text bold component='span' variant='body'>
            {i18n.t('Nombre de usuario')}:
          </Text>
          <Text component='span' variant='body'>
            {username}
          </Text>
        </Sc.ModalCredentialsContent>
        <Sc.ModalCredentialsContent>
          <Text bold component='span' variant='body'>
            {i18n.t('Contraseña')}:
          </Text>
          <Text component='span' variant='body'>
            {password ? password : '********'}
          </Text>
        </Sc.ModalCredentialsContent>
      </Sc.ModalCredentialsContainer>
    </Modal>
  )
}

export default ModalInfoUser
